import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const IntermediarioPagina = () => {
  return (
    <div className="intermediario-container">
      <GroupLightComponent
        groupIds={["grupo05", "grupo07", "grupo08","grupo09"]}
        startIndex={20}  // Começa onde o térreo termina
        endIndex={40}    // Ajuste conforme o número total de luzes
        pageTitle="Luzes do Intermediário" 
      />
    </div>
  );
};

export default IntermediarioPagina;